import * as Scrivito from "scrivito"

import { FeatureWidgetView } from "../FeatureWidget/Components/FeatureWidgetView"
import { AccordionFeatureWidget } from "./AccordionFeatureWidgetClass"

Scrivito.provideComponent(AccordionFeatureWidget, ({ widget }) => (
  <FeatureWidgetView
    className="accordion-feature"
    headline={
      <Scrivito.ContentTag tag="h3" content={widget} attribute="headline" />
    }
    text={<Scrivito.ContentTag content={widget} attribute="text" />}
    content={<Scrivito.ContentTag content={widget} attribute="accordion" />}
    buttons={<Scrivito.ContentTag content={widget} attribute="cta" />}
    alternativeBackground={widget.get("alternativeBackground")}
  />
))
